import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { validateDonationForm } from "../utils/validation";
import { update_donation_by_id } from "../api/donations_api";
export const useDonationLogic = ({ formData, setFormData, updating, onCreditSuccess }) => {
    const checkoutRef = useRef(null);
    const [perInstallment, setPerInstallment] = useState("0.00");
    const [isCreditReady, setIsCreditReady] = useState(false);

    
    const data = formData || { paymentMethod: 'credit', status: 'pending' };

    const isCredit = data.paymentMethod === "credit";
    const isCashOrManual = ["cash", "manual"].includes(data.paymentMethod);
    const creditSuccess = isCredit && data.status === "success";
    const creditFailed = isCredit && data.status === "failed";

    const isFieldDisabled = useCallback((fieldName) => {
        if (!updating) return false;
        if (creditSuccess) return !["notes", "receipt_id"].includes(fieldName);
        if (isCashOrManual) return !["amount", "currency", "notes", "receipt_id", "installments", "date"].includes(fieldName);
        if (creditFailed) {
            return !["amount", "currency", "installments", "date", "notes", "receipt_id", "cardHolderName", "cardHolderId"].includes(fieldName);
        }
        return true;
    }, [updating, creditSuccess, isCashOrManual, creditFailed]);

    useEffect(() => {
        const amount = parseFloat(data.amount);
        const inst = Number(data.installments);
        if (!amount || !inst || inst <= 0) {
            setPerInstallment("0.00");
        } else {
            setPerInstallment((amount / inst).toFixed(2));
        }
    }, [data.amount, data.installments]);

    const validationErrors = useMemo(() => {
        return data ? validateDonationForm(data, updating) : {};
    }, [data, updating]);

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        let finalValue = value;
        
        if (["bankNumber", "bankAccount", "bankBranch"].includes(name)) {
            finalValue = value.replace(/\D/g, '');
        }
        if (name === "amount" && Number(value) < 0) return;

        setFormData(prev => ({ ...prev, [name]: finalValue }));
    }, [setFormData]);

    const handlePaymentMethodChange = useCallback((e) => {
        const method = e.target.value;
        setFormData(prev => ({
            ...prev,
            paymentMethod: method,
            status: (method === "cash" || method === "manual") ? "success" : "pending",
            cardHolderName: "", cardHolderId: "", bankNumber: "", bankAccount: "", bankBranch: "", accountHolder: ""
        }));
    }, [setFormData]);

    const handleCreditPayment = async () => {
        try {
            if (formData.paymentMethod === "credit") {
                const selectedDate = new Date(formData.date).setHours(0,0,0,0);
                const today = new Date().setHours(0,0,0,0);
                
                if (selectedDate < today) {
                    alert("לא ניתן לבצע סליקת אשראי עבור תאריך מהעבר. אנא בחרי בתאריך של היום או תאריך עתידי.");
                    return;
                }
            }
            if (!checkoutRef.current) {
                alert("מערכת הסליקה לא נטענה כראוי");
                return;
            }
    
            // ביצוע התשלום
            const paymentId = await checkoutRef.current.pay();
    
            const updatedData = {
                ...formData,
                status: "success",
                providerTransactionId: paymentId
            };
    
            onCreditSuccess(updatedData);
        } catch (err) {
            // --- כאן השינוי הקריטי ---
            console.error("Payment Error:", err);
            
            // חילוץ הודעת השגיאה הספציפית מ-Stripe אם קיימת
            const errorMessage = err.message || (err.error && err.error.message) || "הסליקה נכשלה";
            
            const failedData = {
                ...formData,
                status: "failed",
                providerTransactionId: null
            };
    
            setFormData(failedData);
    
            if (updating && formData.id) {
                await update_donation_by_id(formData.id, failedData);
            }
    
         
            alert(`שגיאת סליקה: ${errorMessage}`);
        }
    };

    return {
        checkoutRef,
        perInstallment,
        isCreditReady,
        setIsCreditReady,
        validationErrors,
        isFieldDisabled,
        handleChange,
        handlePaymentMethodChange,
        handleCreditPayment,
        creditSuccess,
        creditFailed
    };
};